import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function LightIcon(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M12 20.0386C11.0218 20.0386 10.1876 19.6934 9.49725 19.0029C8.80675 18.3126 8.4615 17.4783 8.4615 16.5001H5C4.5875 16.5001 4.23442 16.3532 3.94075 16.0594C3.64692 15.7657 3.5 15.4126 3.5 15.0001C3.5 12.7886 4.24425 10.8707 5.73275 9.24638C7.22125 7.62205 9.06033 6.71688 11.25 6.53088V4.44238C11.25 4.22988 11.3219 4.0518 11.4658 3.90813C11.6096 3.7643 11.7878 3.69238 12.0003 3.69238C12.2129 3.69238 12.391 3.7643 12.5345 3.90813C12.6782 4.0518 12.75 4.22988 12.75 4.44238V6.53088C14.9397 6.71688 16.7788 7.62205 18.2673 9.24638C19.7558 10.8707 20.5 12.7886 20.5 15.0001C20.5 15.4126 20.3531 15.7657 20.0592 16.0594C19.7656 16.3532 19.4125 16.5001 19 16.5001H15.5385C15.5385 17.4783 15.1932 18.3126 14.5027 19.0029C13.8124 19.6934 12.9782 20.0386 12 20.0386ZM5 15.0001H19C19 13.0668 18.3167 11.4168 16.95 10.0501C15.5833 8.68347 13.9333 8.00013 12 8.00013C10.0667 8.00013 8.41667 8.68347 7.05 10.0501C5.68333 11.4168 5 13.0668 5 15.0001ZM12.0025 18.5386C12.5637 18.5386 13.0433 18.3391 13.4413 17.9399C13.8394 17.5406 14.0385 17.0606 14.0385 16.5001H9.9615C9.9615 17.063 10.1613 17.5434 10.561 17.9414C10.9607 18.3396 11.4412 18.5386 12.0025 18.5386Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}